// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { observable, action } from "mobx";
import i18next from "i18next";

export default class TranslationStore {
  @observable lang: string = "es";
  @observable langLabel: string = "ca";
  @observable languages: Array<string> = ["es", "ca"];

  @action setLanguage = (lang: string) => {
    this.lang = lang;
    this.langLabel = lang === "ca" ? "es" : 'ca';
    i18next.changeLanguage(this.lang);
  };
}
